import React from "react";
import {
  List,
  Filter,
  Datagrid,
  TextField,
  EmailField,
  TextInput,
  BooleanInput,
  BooleanField,
  downloadCSV,
  ReferenceField,
  ImageField,
  DateField,
} from "react-admin";

import { unparse as convertToCSV } from "papaparse/papaparse.min";
import "./image.css";

const CaseSensitiveFilter = (props) => {
  return (
    <TextInput
      source="name"
      alwaysOn
      {...props}
      onChange={(props) => {
        return {};
      }}
    />
  );
};

const UserFilter = (props) => (
  <Filter {...props}>
    <BooleanInput label="Mentors Only" source="isMentor" />
    <BooleanInput label="Profile Verified Only" source="profileVerified" />
    <CaseSensitiveFilter label="Search by Name" source="name@case" />
  </Filter>
);

const exporter = (records) => {
  const UserExport = records.map((record) => {
    const array = [];
    array.push(record.name);
    array.push(record.email_);
    array.push(record.mobileNo);
    array.push(record.isMentor ? "Yes" : "No");
    array.push(record.processingFee);
    array.push(record.mentorFee);

    return array;
  });

  const csv = convertToCSV({
    fields: [
      "Name",
      "Email",
      "Contact",
      "Mentor",
      "Processing Fee",
      "Mentor Fee",
    ],
    data: UserExport,
  });

  downloadCSV(csv, "User");
};

export const UserList = ({ permissions, ...props }) => {
  return (
    <List
      {...props}
      title="User"
      bulkActionButtons={false}
      filters={<UserFilter />}
      exporter={exporter}
    >
      <Datagrid rowClick="show">
        {/* <UserAvatar source="profileImage" label="User" /> */}
        <ImageField
          className="thumbNailView"
          source="profileImage._url"
          label="User"
        />

        <TextField source="name" />
        <EmailField label="Email" source="email_" />
        <TextField label="Mobile Number" source="mobileNo" />
        <BooleanField label="Mentor" source="isMentor" />
        <ReferenceField
          label="Badge"
          source="userBadge.id"
          reference="UserBadge"
        >
          <TextField source="badgeName" />
        </ReferenceField>
        <TextField source="mentorFee" />
        <TextField source="processingFee" />
        <TextField source="OptIn" label="Is User Opted In" />
        <DateField source="lastLoggedin" label="Last LoggedIn Date" />
      </Datagrid>
    </List>
  );
};
export default UserList;
